import { environment } from './../../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ComponenteModel } from 'app/model/endereco/componente.model';
import { observeOn } from 'rxjs/operator/observeOn';
import { QtdAlocavelModel } from 'app/components/endereco-components/componente/componentes-filhos/componentes-filhos.component';

@Injectable()
export class ComponenteService {

  apiURL = environment.API;

  httpOptions = {
    headers : new HttpHeaders()
  .set('Content-Type', 'application/json')
  .set('ticket', sessionStorage.getItem('ticket-ECM'))
  .set('Authorization', sessionStorage.getItem('tokenAuth'))
  };

  constructor(private httpClient: HttpClient) { }

  listarComponentesModulo(moduloId: Number): Observable<Array<ComponenteModel>> {
    return this.httpClient.get<Array<ComponenteModel>>(this.apiURL + `/listar-componentes-modulo/${moduloId}`, this.httpOptions);
  }

  getComponente(moduloId: Number, componenteId: Number): Observable<Array<ComponenteModel>> {
    return this.httpClient.get<Array<ComponenteModel>>(this.apiURL + `/listar-componente/${moduloId}/${componenteId}`, this.httpOptions);
  }

  adicionarComponente(componente: ComponenteModel, qtdHorizontal:number, qtdVertical:number, qtdProfundidade: number) {
    const headers = new HttpHeaders()
      .set('ticket', sessionStorage.getItem('ticket-ECM'))
      .set('Authorization', sessionStorage.getItem('tokenAuth'));

    // observe: 'events', reportProgress: true,
    return this.httpClient.post(this.apiURL + `/adicionar-componentes?qtdHorizontal=${qtdHorizontal}&qtdVertical=${qtdVertical}&qtdProfundidade=${qtdProfundidade}`, componente,
    {headers});
  }

  getComponenteUnico(componenteId: Number): Observable<ComponenteModel> {
    return this.httpClient.get<ComponenteModel>(this.apiURL + `/listar-componente-unico/${componenteId}`, this.httpOptions);
  }

  excluirComponentes(moduloId: Number) {
    const headers = new HttpHeaders()
      .set('ticket', sessionStorage.getItem('ticket-ECM'))
      .set('Authorization', sessionStorage.getItem('tokenAuth'));

    return this.httpClient.delete(this.apiURL + `/apagar-componentes/${moduloId}`, { headers, responseType: 'text'})
  }

  adicionarComponentesFilhos(componentePaiId: Number, componente: ComponenteModel, qtdHorizontal:number, qtdVertical:number, qtdProfundidade: number): Observable<ComponenteModel[]> {
    return this.httpClient.post<ComponenteModel[]>(this.apiURL + 
      `/adicionar-componentes-filhos/${componentePaiId}?qtdHorizontal=${qtdHorizontal}&qtdVertical=${qtdVertical}&qtdProfundidade=${qtdProfundidade}`, 
      componente, this.httpOptions);
  }

  nodesTree(componenteId: number) {
    return this.httpClient.get(this.apiURL + `/montar-arvore/${componenteId}`, this.httpOptions);
  }

  desativarAtivarComponente(componenteId: number) {
    const headers = new HttpHeaders()
      .set('ticket', sessionStorage.getItem('ticket-ECM'))
      .set('Authorization', sessionStorage.getItem('tokenAuth'));

    return this.httpClient.get(this.apiURL + `/ativar-desativar-componente/${componenteId}`, { headers, responseType: 'text'});
  }

  editarComponente(componente: ComponenteModel, qtdHorizontal, qtdVertical, qtdProfundidade): Observable<ComponenteModel> {
    return this.httpClient.put<ComponenteModel>(this.apiURL + `/editar-componente?qtdHorizontal=${qtdHorizontal}&qtdVertical=${qtdVertical}&qtdProfundidade=${qtdProfundidade}`, componente, this.httpOptions);
  }

  getQtdAlocavelPorComponente(componenteId: Number): Observable<QtdAlocavelModel> {
    return this.httpClient.get<QtdAlocavelModel>(this.apiURL + `/buscar-qtd-alocavel-componente/${componenteId}`, this.httpOptions);
  }

  ativarTodosComponentes(componenteId: Number) {
    const headers = new HttpHeaders()
      .set('ticket', sessionStorage.getItem('ticket-ECM'))
      .set('Authorization', sessionStorage.getItem('tokenAuth'));

    return this.httpClient.get(this.apiURL + `/ativar-todos-componente/${componenteId}`, { headers, responseType: 'text'});
  }

  inativarTodosComponentes(componenteId: Number) {
    const headers = new HttpHeaders()
      .set('ticket', sessionStorage.getItem('ticket-ECM'))
      .set('Authorization', sessionStorage.getItem('tokenAuth'));

    return this.httpClient.get(this.apiURL + `/inativar-todos-componente/${componenteId}`, { headers, responseType: 'text'});
  }

}



// WEBPACK FOOTER //
// /app/src/app/service/endereco/componente.service.ts